import { render, staticRenderFns } from "./FormatPageObjectsSelector.vue?vue&type=template&id=366c7900&scoped=true&"
import script from "./FormatPageObjectsSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatPageObjectsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageObjectsSelector.vue?vue&type=style&index=0&id=366c7900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c7900",
  null
  
)

export default component.exports